import React from "react";
import { Dialog, Box } from "@mui/material";
import warning from "../../../../assets/images/warning.svg";
import CustomButton from "../../../components/buttons/CustomButton";

const DeletePopup = ({ open, selectedUsers, onClose, onConfirm, type='user' }) => {

    return (
        <Dialog
            open={open}
            onClose={onClose}
            sx={{
                '& .MuiPaper-root': {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    padding: "20px",
                    borderRadius: "8px",
                    minWidth: "300px"
                }
            }}
        >
            <img src={warning} alt="warning" style={{ width: '48px', height: '48px', marginBottom: '16px' }} />

            <span style={{ fontSize: "16px", fontWeight: "500", textAlign: 'center', marginBottom: '8px' }}>
                Are you sure you want to delete the below {type}?
                {
                    selectedUsers && selectedUsers.length > 0 && type === 'user' && (
                        selectedUsers.map((user, index) => (
                            <div key={index} style={{ fontSize: "12px", fontWeight: "400", marginTop: "4px" }}>
                                {user}
                            </div>
                        ))
                    )
                }
                {/* {
                    selectedUsers && selectedUsers.length > 0 && type === 'persona' && (
                       <div style={{ fontSize: "12px", fontWeight: "400", marginTop: "4px" }}>
                            {selectedUsers}
                        </div>
                    )
                } */}
            </span>

            <span style={{ fontSize: "12px", textAlign: 'center', marginTop: '10px' }}>
                By deleting this row you will not be able to
            </span>
            <span style={{ fontSize: "12px", textAlign: 'center', marginTop: '0px' }}>
                to restore again
            </span>

            <Box sx={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "16px" }}>
                <CustomButton
                    type="reviewCartCancel"
                    label="Cancel"
                    onClick={onClose}
                />
                <CustomButton
                    type="reviewCartSubmit"
                    label="Delete"
                    onClick={onConfirm}
                />
            </Box>
        </Dialog>
    )
}

export default DeletePopup;